<template>
  <div class="is-size-7">
    <span class="help has-text-weight-semibold"
      >Passwords must contain at least:</span
    >
    <ul class="has-text-left">
      <li>
        <span
          class="icon"
          :class="
            checkPasswordConditions.length
              ? 'has-text-success'
              : 'has-text-grey-light'
          "
        >
          <i
            :class="
              checkPasswordConditions.length ? 'far fa-check' : 'far fa-times'
            "
          />
        </span>
        Eight characters
      </li>
      <li>
        <span
          class="icon"
          :class="
            checkPasswordConditions.uppercase
              ? 'has-text-success'
              : 'has-text-grey-light'
          "
        >
          <i
            :class="
              checkPasswordConditions.uppercase
                ? 'far fa-check'
                : 'far fa-times'
            "
          />
        </span>
        One uppercase letter
      </li>
      <li>
        <span
          class="icon"
          :class="
            checkPasswordConditions.lowercase
              ? 'has-text-success'
              : 'has-text-grey-light'
          "
        >
          <i
            :class="
              checkPasswordConditions.lowercase
                ? 'far fa-check'
                : 'far fa-times'
            "
          />
        </span>
        One lowercase letter
      </li>
      <li>
        <span
          class="icon"
          :class="
            checkPasswordConditions.special
              ? 'has-text-success'
              : 'has-text-grey-light'
          "
        >
          <i
            :class="
              checkPasswordConditions.special ? 'far fa-check' : 'far fa-times'
            "
          />
        </span>
        One special character
      </li>
      <li>
        <span
          class="icon"
          :class="
            checkPasswordConditions.number
              ? 'has-text-success'
              : 'has-text-grey-light'
          "
        >
          <i
            :class="
              checkPasswordConditions.number ? 'far fa-check' : 'far fa-times'
            "
          />
        </span>
        One number
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PasswordTooltip',
  props: {
    password: {
      type: String,
      required: true
    }
  },
  computed: {
    checkPasswordConditions() {
      const password = this.password || ''
      if (!password) return {}
      const specialChars = /[!@#$%^&*()+_\-=}{[\]|:;"/?.><,`~]/
      return {
        length: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        lowercase: /[a-z]/.test(password),
        special: specialChars.test(password),
        number: /\d/.test(password)
      }
    }
  }
}
</script>
